import _ from 'lodash';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useActiveScheduledItems } from 'src/dispensary/hooks/use-active-scheduled-items';

export default function useDispensaryMenuSections() {
  const { dispensary, ...dispensaryApolloValues } = useDispensary();
  const allMenuSections = _.sortBy(dispensary?.menuSections, 'position');

  const menuSections = useActiveScheduledItems({
    items: allMenuSections ?? [],
    getSchedule: (section) => {
      // Only collection sections have schedules
      if (section?.sectionType !== 'COLLECTION') {
        return null;
      }
      return section.collectionSchedule;
    },
    dispensaryTimezone: dispensary?.timezone,
    enablePolling: true,
  });

  return { menuSections, ...dispensaryApolloValues };
}
